let mutations = {
  // 更新oss上传签名信息
  setUploadParams(state, params) {
    state.uploadParams = params;
  },
  setActiveMenu(state, active) {
    state.currentMenu = active;
  },
  setDevice(state, isIPhoneX) {
    state.isIPhoneX = isIPhoneX;
  },
  setCurrentPageName(state, name) {
    state.currentPage = name;
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutation.js